var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { findElementByType } from '../helpers';

const RTCPeerConnection = config => new window.RTCPeerConnection(config);

const getUserMedia = constraints => navigator.mediaDevices.getUserMedia(constraints);

const getDisplayMedia = constraints => navigator.mediaDevices.getDisplayMedia(constraints);

const enumerateDevices = () => navigator.mediaDevices.enumerateDevices();

const getSupportedConstraints = () => navigator.mediaDevices.getSupportedConstraints();

const streamIsValid = stream => stream && stream instanceof MediaStream;

const attachMediaStream = (tag, stream) => {
  const element = findElementByType(tag);

  if (element === null) {
    return;
  }

  if (!element.getAttribute('autoplay')) {
    element.setAttribute('autoplay', 'autoplay');
  }

  if (!element.getAttribute('playsinline')) {
    element.setAttribute('playsinline', 'playsinline');
  }

  element.srcObject = stream;
};

const detachMediaStream = tag => {
  const element = findElementByType(tag);

  if (element) {
    element.srcObject = null;
  }
};

const muteMediaElement = tag => {
  const element = findElementByType(tag);

  if (element) {
    element.muted = true;
  }
};

const unmuteMediaElement = tag => {
  const element = findElementByType(tag);

  if (element) {
    element.muted = false;
  }
};

const toggleMuteMediaElement = tag => {
  const element = findElementByType(tag);

  if (element) {
    element.muted = !element.muted;
  }
};

const setMediaElementSinkId = (tag, deviceId) => __awaiter(void 0, void 0, void 0, function* () {
  const element = findElementByType(tag);

  if (element === null) {
    return false;
  }

  try {
    yield element.setSinkId(deviceId);
    return true;
  } catch (error) {
    return false;
  }
});

const sdpToJsonHack = sdp => sdp;

const stopStream = stream => {
  if (streamIsValid(stream)) {
    stream.getTracks().forEach(t => t.stop());
  }

  stream = null;
};

export { RTCPeerConnection, getUserMedia, getDisplayMedia, enumerateDevices, getSupportedConstraints, streamIsValid, attachMediaStream, detachMediaStream, sdpToJsonHack, stopStream, muteMediaElement, unmuteMediaElement, toggleMuteMediaElement, setMediaElementSinkId };